<template>
    <div>
        <div class="card-body">
            <table class="table">
                <thead>
                <tr>
                    <th>月份</th>
                    <th>开始时间</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(studentCart_classPlan,index) in $parentInfo.studentCart.studentCart_classPlans">

                    <td>{{studentCart_classPlan.date}}</td>
                    <td>
                        <el-date-picker
                                v-model="studentCart_classPlan.start_date"
                                type="date"
                                :clearable="false"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                @change="changeDate()"
                                :disabled="studentCart_classPlan.monthJudge"
                                :picker-options="$parentInfo.studentCart.dialog_ChooseWanTuoClassPlan.pickerOptions0">
                        </el-date-picker>
                    </td>
                    <td>
                        <el-button
                                :class="{checked:studentCart_classPlan.status=='cancel'}"
                                :disabled="studentCart_classPlan.status!='active'"
                                type="primary" plain size="mini"
                                @click="selectClassPlan(index,studentCart_classPlan.start_date,'cancel')"
                                :loading="button_loading">退选
                        </el-button>
                        <el-button
                                :class="{checked:studentCart_classPlan.status=='active'}"
                                :disabled="studentCart_classPlan.status!='cancel'"
                                type="primary" plain size="mini"
                                @click="selectClassPlan(index,studentCart_classPlan.start_date,'active')"
                                :loading="$parentInfo.studentCart.dialog_ChooseWanTuoClassPlan.button_loading">选择
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
    export default {
        name:'Dialog_ChooseWanTuoClassPlan',
        data() {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentCart.dialog_ChooseWanTuoClassPlan.button_loading = false;
            this.$parentInfo.studentCart.dialog_ChooseWanTuoClassPlan.loading = true;
            this.handleClassPlan();
        },
        mounted() {
        },
        methods: {
            //取得课程课时情况 true
            handleClassPlan() {
                this.$wApi.send(this.$parentInfo.path, 'get_student_wanTuoClassPlan', {
                    'studentCart_id': this.$store.state.modal.data.cart_id,
                });
            },
            //选课 true
            selectClassPlan(index, start_date, status) {
                this.$parentInfo.studentCart.dialog_ChooseWanTuoClassPlan.index = index;
                this.$parentInfo.studentCart.dialog_ChooseWanTuoClassPlan.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'select_wanTuoClassPlan', {
                    'studentCart_id': this.$store.state.modal.data.cart_id,
                    'status': status,
                    'start_date': start_date,

                });
            },
        }
    };
</script>

<style scoped>
    .checked {
        background: #0b67cd;
    }
</style>
